import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { defaultTo } from 'ramda';
import { connect } from 'react-redux';

import magic from '../../../../util/magic';
import { routes } from '../../../../routes';
import List from './List';
import Create from './Create';
import Edit from './Edit';

const mapStore = ({ certifications, fellowshipServiceTypes, user }) => ({
  certifications,
  fellowshipServiceTypes,
  registrations: user.latestRegistrations.filter((r) => r.status != magic.complete && r.trainingId == null),
});

const Experiences = (props) => (
  <Switch>
    <Route exact path={routes.certificationsAndTraining.experience.root} render={() => <List {...props} />} />
    <Route exact path={routes.certificationsAndTraining.experience.add} render={() => <Create {...props} />} />
    <Route path={routes.certificationsAndTraining.experience.edit} render={() => <Edit {...props} />} />
  </Switch>
);

export default connect(mapStore)(Experiences);
